import { createCustomAction } from 'typesafe-actions';
import { SET_EXPRESSION_TESTER_OPEN } from './constants';

export const setExpressionTesterOpen = createCustomAction(SET_EXPRESSION_TESTER_OPEN, (type) => {
    return (open: boolean) => ({ type, open });
});
